import { useEffect, useState } from "react";
import Pitanje from "../Pitanje/PitanjeKorisnik";
import anketaService from "../../services/anketa.service";
import popunjeniOdgovorService from "../../services/popunjeniOdgovor.service";
import "./ViewAnketaPage.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Background from "../../components/Background4";
import { formatDateTime } from "../../utils/formatDateTime";
import { Modal, Button } from "antd";
import saglasnostService from "../../services/saglasnost.service";
import dayjs from "dayjs";
import NotFound from "../../components/NotFound"; 

const ViewAnketaPageKorisnik = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const parsedAnketaId = Number(id);
  const [anketa, setAnketa] = useState(null);
  const [pitanja, setPitanja] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [unfinishedModalVisible, setUnfinishedModalVisible] = useState(false);
  const [showSaglasnostModal, setShowSaglasnostModal] = useState(false);
  const [saglasnostText, setSaglasnostText] = useState("");
  const [notFound, setNotFound] = useState(false);
  const handleModalOk = () => {
    setModalVisible(false);
    handleSubmit();
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleUnfinishedModalOk = () => {
    setUnfinishedModalVisible(false);
  };

  const checkData = () => {
    const obaveznaPitanja = pitanja.filter((p) => p.obavezno);

    const allFinished = obaveznaPitanja.every((pitanje) => {
      const odgovor = odgovori[pitanje.id];

      if (odgovor === undefined || odgovor === null) return false;

      if (Array.isArray(odgovor)) {
        return odgovor.length > 0;
      }

      return odgovor !== "";
    });

    if (allFinished) {
      setModalVisible(true);
    } else {
      setUnfinishedModalVisible(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await anketaService.getById(parsedAnketaId);
        setAnketa(response.data);

        const pitanjaResponse = await anketaService.getPitanjaSaOdgovorima(
          parsedAnketaId
        );
        setPitanja(pitanjaResponse.data);
        if (response.data.saglasnostId) {
          const saglasnostRes = await saglasnostService.getById(
            response.data.saglasnostId
          );
          setSaglasnostText(saglasnostRes.data.sadrzaj);
          setShowSaglasnostModal(true);
        }
      } catch (error) {
         if (error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("Greška pri učitavanju ankete:", error);
        }
      }
    };

    if (parsedAnketaId) fetchData();
  }, [parsedAnketaId]);
   const [odgovori, setOdgovori] = useState({});
 if (notFound) return <NotFound />;
 

  const handlePromjenaOdgovora = (
    pitanjeId,
    tekstOdgovora,
    checked = true,
    tipPitanja = ""
  ) => {
    setOdgovori((prev) => {
      if (tipPitanja === "VISESTRUKI_IZBOR") {
        const trenutno = prev[pitanjeId] || [];
        const noviOdgovori = checked
          ? [...trenutno, tekstOdgovora]
          : trenutno.filter((o) => o !== tekstOdgovora);
        return { ...prev, [pitanjeId]: noviOdgovori };
      }
      return {
        ...prev,
        [pitanjeId]: tekstOdgovora,
      };
    });
  };

  const handleSubmit = async () => {
   const now = dayjs().format("YYYY-MM-DDTHH:mm:ss");
    const sviOdgovori = [];

    for (const [pitanjeId, odgovor] of Object.entries(odgovori)) {
      if (Array.isArray(odgovor)) {
        odgovor.forEach((tekst) =>
          sviOdgovori.push({
            odgovorTekst: tekst,
            vremenskaOznaka: now,
            pitanjeId: Number(pitanjeId),
          })
        );
      } else {
        sviOdgovori.push({
          odgovorTekst: odgovor,
          vremenskaOznaka: now,
          pitanjeId: Number(pitanjeId),
        });
      }
    }

    try {
      await popunjeniOdgovorService.addBatchPopunjeniOdgovor(sviOdgovori);

      Modal.success({
        title: "Uspješno poslano!",
        content: "Hvala na ispunjavanju ankete.",
      });

      navigate(`/ankete/sve`);
    } catch (error) {
      Modal.error({
        title: "Greška pri slanju",
        content: "Pokušajte ponovo kasnije.",
      });
    }
  };

  const handleSaglasnostOk = () => {
    setShowSaglasnostModal(false);
  };

  const handleSaglasnostCancel = () => {
    navigate("/ankete/sve");
  };

  if (!anketa) return <p>Učitavanje...</p>;

  return (
    <div>
      <Background />
      <Modal
        title="Saglasnost"
        open={showSaglasnostModal}
        onOk={handleSaglasnostOk}
        onCancel={handleSaglasnostCancel}
        okText="Prihvati"
        cancelText="Odbij"
        className="saglasnost-modal"
      >
        <p>{saglasnostText}</p>
      </Modal>
      {!showSaglasnostModal && (
        <div className="container">
          <div className="anketa-card">
            <h2 className="modal-title" style={{ width: "90%" }}>
              {anketa.naziv}
            </h2>
            <div className="anketa-info-div">
              <h4 className="anketa-subtitle">{anketa.opis}</h4>
              <p>Datum kreiranja: {formatDateTime(anketa.datumKreiranja)}</p>
              <p>Datum važenja: {formatDateTime(anketa.datumVazenja)}</p>
            </div>

            {pitanja
              .sort((a, b) => a.pozicija - b.pozicija)
              .map((p, index) => (
                <Pitanje
                  key={p.id}
                  pitanje={p}
                  onPromjenaOdgovora={handlePromjenaOdgovora}
                  trenutniOdgovori={odgovori}
                />
              ))}

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                type="primary"
                size="large"
                onClick={checkData}
                className="button-primary"
              >
                Pošalji rezultate
              </Button>
            </div>
          </div>
        </div>
      )}
      <Modal
        title="Završetak rada"
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="Nastavi"
        cancelText="Povratak"
        className="saglasnost-modal"
      >
        <p>Da li ste sigurni da želite da predate odgovore?</p>
      </Modal>

      <Modal
        title="Greška"
        open={unfinishedModalVisible}
        onCancel={handleUnfinishedModalOk}
        footer={[
          <Button key="back" type="primary" onClick={handleUnfinishedModalOk}>
            Povratak
          </Button>,
        ]}
        className="saglasnost-modal"
      >
        <p>
          Niste popunili odgovore na sva obavezna pitanja. Molimo Vas da
          završite anketu do kraja.
        </p>
      </Modal>
    </div>
  );
};

export default ViewAnketaPageKorisnik;
